import { useContext } from 'react';
import { AuthContext } from '../config/AuthenticationProvider';

export const useAuthentication = () => {
  return {
    ...useContext(AuthContext),
  };
};
